export default [{
  path: '/cnd-municipal',
  component: {
    name: 'cndmunicipalBase',
    template: '<router-view />',
    meta: {
      resource: 'cnd_municipal',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'cndmunicipal-view',
    component: () => import('@/app/cnd-municipal/CndMunicipalView.vue'),
    meta: {
      resource: 'cnd_municipal',
      action: 'read',
      navActiveLink: 'cndmunicipal-view',
      pageTitle: 'Municipal',
      breadcrumb: [
        {
          text: 'Municipal',
          to: { name: 'cndmunicipal-view' },
          active: true,
        },
      ],
    },
  }],
},
]
